import axiosInstance from '../../../helpers/axios';

export function downloadFile(url, filename) {
    return axiosInstance.get(url, { responseType: 'blob' }).then((response) => {
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    });
}
